import { Watch, Inject, Provide, Prop } from "vue-property-decorator";
import Vue from "vue";
import Component from "vue-class-component";
import cloneDeep from "lodash/cloneDeep";
import type { ElForm } from "element-ui/types/form";
import uuid4 from "uuid";
import AddButton from "../shopDisplaySketchMap/addButton";
import { noop, numberToArray, QinggerLibUtils } from "@/util";
import { IPSService } from "@/services/ipsServices";
import validateParams from "@/library/utils/paramFilter";
import { RenovationColor, RenovationColorList } from "@/views/components/styleConfig";
import ShopDisplayEdit from "@/views/components/shopDisplaySketchMap/displayEdit";
import ShopDisplay from "@/views/components/shopDisplaySketchMap/display";
import imagePreview from "@/views/components/imgPreview";
import { Functions } from "@/library/utils/functions";

const isset = QinggerLibUtils.isset;

export const defaultLogo = "https://ssl-picture.tenyun.runsasoft.com/45547590-82a1-11ea-91a3-a115d0563d85";
export const defaultImg = "https://ssl-picture.tenyun.runsasoft.com/2d97c9b0-83ab-11ea-b0d5-8b89156e3a17";
export const defaultBg = "https://ssl-picture.tenyun.runsasoft.com/fce0e910-8372-11ea-b0d5-8b89156e3a17";

export enum ShowWindowShowType {
	LINE = 1, // 一行2个
	SCROLL, // 横向滚动
	BIG, // 大图
}

export const ShowWindowShowTypeImg = {
	[ShowWindowShowType.LINE]: "https://ssl-picture.tenyun.runsasoft.com/c6586a30-807a-11ea-b75b-775d8e954200",
	[ShowWindowShowType.BIG]: "https://ssl-picture.tenyun.runsasoft.com/ad49ecd0-807a-11ea-ac87-9ba7dcb3330b",
	[ShowWindowShowType.SCROLL]: "https://ssl-picture.tenyun.runsasoft.com/bd4f07a0-807a-11ea-ac87-9ba7dcb3330b",
};

const ShopInfoService = ["decorationMallInfo", "decorationMallInfo", "siteMallInfo"];
const ShopSaveService = ["decorationMallSave", "decorationMallSave", "siteMallSave"];
const PageInfoService = ["miniPageInfo", "miniPageInfo", "siteMicroPageConfigInfo"];

export const selectTypeToTitle = {
	Swiper: "店铺形象图",
	Site: "商城页",
	LabelClass: "分类导航",
	ShowWindow: "商品橱窗",
	Propagate: "图文广告",
	video: "视频",
	Blank: "辅助空白",
	blank: "辅助空白",
	search: "搜索",
	HoverIcon: "悬浮图标",
	ShowWindowGroup: "商品橱窗",
	QiKanShowWindow: "期刊橱窗",
	weiGroup: "多页橱窗",
	guide: "添加引导",
	pageVideo: "视频",
	iconMenu: "图标导航",
};

@Component({
	// mixins: [style],
	components: {
		ShopDisplayEdit,
		ShopDisplay,
	},
})
export default class Shop extends Vue {
	@Prop({ default: RenovationColor.redOrangeWhite })
	themeCode: number;

	@Prop()
	fromPage: number;

	// 运营模式 1 镜单  2 镜千 3 云单 4 云千
	@Inject({ default: 0 })
	mode: number;

	// @ts-expect-error
	theme = RenovationColorList[this.themeCode];

	$refs: {
		config: ElForm;
	};

	// 商品分类
	connectedClass = [];

	classList = [];

	get ShowWindowList(): any {
		return (
			this.data
				.map((v: any, i) => {
					v._index = i;
					return v;
				})
				.filter((i) => i.fieldType === "ShowWindow") || []
		);
	}

	get QiKanShowWindowList(): any {
		return (
			this.data
				.map((v: any, i) => {
					v._index = i;
					return v;
				})
				.filter((i) => i.fieldType === "QiKanShowWindow") || []
		);
	}

	get PropagateList(): any {
		return (
			this.data
				.map((v: any, i) => {
					v._index = i;
					return v;
				})
				.filter((i) => i.fieldType === "Propagate") || []
		);
	}

	data: DisplayData[] = [];

	copyData: DisplayData[] = [];

	// 弹窗选中的分类
	selectDiallogCLass = null;

	arr10 = numberToArray(10);
	arr20 = numberToArray(20);

	activedIndex = -1;

	@Watch("data", { deep: true })
	watchData(n) {
		this.activedIndex = n.findIndex((v) => v.isActived) || 0;
		// this.data = n;
	}

	/**
	 * 获取关联分类
	 */
	public getAttributeList(): Promise<any> {
		return IPSService.getAttributeList().then((res) => {
			return isset(res, "list") ? res.list : [];
		});
	}

	// 获取网点分类配置
	getClassList() {
		return IPSService.siteClassList({
			postParams: {
				siteId: +this.$route.params.siteId,
			},
		}).then((response) => {
			return response.list || [];
		});
	}

	async mounted() {
		this.mode === 2 && (this.classList = await this.getClassList());
		// 获取商品列表
		this.connectedClass = await this.getAttributeList();
		this.getData();
	}

	getData(loading?) {
		const sgId = Number.parseInt(this.$route.params.id) || Number.parseInt(this.$route.params.sgId);
		IPSService[ShopInfoService[this.mode]]({ postParams: { sgId, siteId: +this.$route.params.siteId } }).then(
			(res: any) => {
				const list = res.list
					.map((v, i) => {
						this.$set(v, "_key", uuid4());
						if (v.fieldType === "Swiper") {
							if (!Array.isArray(v.desc)) {
								v.desc = [v.desc];
							}
							if (!(v as DisplaySwiperData).desc[0].imageUrl) {
								(v as DisplaySwiperData).desc[0].imageUrl = defaultBg;
							}
						}
						if (v.fieldType === "ShowWindow" || v.fieldType === "ShowWindowGroup") {
							const defaultDesc = {
								caseType: 1,
								caseName: "",
								fontSize: 28,
								style: [],
								caseNum: 4,
								caseGroup: [],
								caseStyle: 1,
								isShowMore: 1,
							};
							v.desc = Object.assign({}, defaultDesc, v.desc);
						}

						if (v.fieldType === "QiKanShowWindow") {
							const defaultDesc = {
								qiKanType: 1,
								qiKanName: "",
								qiKanSize: 28,
								style: [],
								qiKanNum: 4,
								qiKanStyle: 1,
							};
							v.desc = Object.assign({}, defaultDesc, v.desc);
						}
						if (v.fieldType === "weiGroup") {
							const defaultDesc = {
								weiGroupList: [{ pageId: null, title: "", caseType: 4, _pageName: "" }],
							};
							v.desc = Object.assign({}, defaultDesc, v.desc);
						}

						if (v.fieldType === "search") {
							v.desc = Object.assign({ margin: 0, keywords: [] }, v.desc);
						}

						// 处理老数据
						if (v.fieldType === "Site") {
							if ((v as DisplaySiteData)?.desc?.siteLogo) {
								(v as DisplaySiteData).desc.siteInfo = {};
								(v as DisplaySiteData).desc.siteInfo.siteLogo = (v as DisplaySiteData)?.desc?.siteLogo;
							}
							if ((v as DisplaySiteData)?.desc?.imageUrl) {
								(v as DisplaySiteData).desc.siteInfo = {};
								(v as DisplaySiteData).desc.siteInfo.siteLogo = (v as DisplaySiteData).desc.imageUrl;
							}
						}

						if (v.fieldType === "LabelClass" && v.desc && v.desc.list && v.desc.list.length) {
							v.desc.list = v.desc.list.map((i) => {
								i.relationList.map((z) => {
									z.selectNames = this.setSelectGoods(z);
									return z;
								});
								return i;
							});
							v.desc.list = v.desc.list.filter((vl) => vl.isAllClass != 1);
						}
						// 2020.07.22 13:56
						// 陈斯说陈儒要求更改数据格式，直接改变动很大，数据转换一下
						if (v.fieldType === "Propagate" && v.desc.config) {
							const config = v.desc.config;
							delete v.desc.config;
							v.desc = {
								...v.desc,
								...config,
							};
						}

						if (v.fieldType === "HoverIcon") {
							const miniPage = v.desc.list.filter((v) => v.page === 16);
							if (miniPage.length) {
								Promise.all(this.getMiniName(miniPage)).then((result) => {
									result.forEach((r) => {
										v.desc.list.forEach((f) => {
											if (r.pageId === f.pageId) {
												f.pageName = r.pageName;
											}
										});
									});
								});
							}
							!v.desc && (v = Object.assign({}, v, { desc: { list: [] }, isActived: false }));
							!v.isActived && (v = Object.assign({}, v, { isActived: false }));
						}
						v = Object.assign({}, v, { isActived: false });
						// v.isActived = i === 1;
						v._sort = i;
						return v;
					})
					.filter((i) => {
						return Object.keys(selectTypeToTitle).includes(i.fieldType);
					});
				this.data = list;
				this.copyData = cloneDeep(list);
				if (loading) {
					const maxNum = Math.max(
						...list
							.filter((v) => {
								return v.fieldType != "blank";
							})
							.map((v) => v.ygswpId),
					);
					const indexAdd = list.findIndex((el) => el.ygswpId === maxNum);
					this.data = this.data.map((v, i) => {
						v.isActived = indexAdd === i;
						this.activedIndex = indexAdd;
						return v;
					});
					this.scrollToActived();
					loading.close();
				}
			},
			() => {
				if (loading) {
					loading.close();
				}
			},
		);
	}

	getMiniName(arr = []): Promise<any>[] {
		arr = arr.filter((v) => !!v.pageId);
		return arr.map((v, i) => {
			return IPSService[PageInfoService[this.mode]]({
				postParams: {
					pageId: v.pageId,
				},
			});
		});
	}

	setSelectGoods(data) {
		if (!data.attrValues) {
			return "";
		}
		const find = this.connectedClass.filter((i) => i.list && i.list.length).find((i) => i.attrCode === data.attrCode);

		if (find) {
			return find.list
				.filter((v) => {
					return data.attrValues.split(",").includes(v.value_no);
				})
				.map((i) => i.value_name);
		}
		return "";
	}

	/**
	 *  验证数据，并选中错误的数据
	 *  */
	validData(): { index: number; message: string } {
		this.data = this.data.map((value) => {
			value.isActived = false;
			return value;
		});
		return Functions.validateDisplayData(this.data, this.mode === 2);
	}

	// 预览
	previewView(postParams, loading?) {
		IPSService.siteMallConfigDisplay({ postParams }).then(
			(response) => {
				if (loading) {
					loading.close();
				}
				imagePreview.open({ img: response.disPlayUrl }).catch(() => {});
			},
			() => {
				if (loading) {
					loading.close();
				}
			},
		);
	}

	save(isPre = 0) {
		// 由于未选择的时候，页面属于销毁的状态，所以要先验证数据，定位错误的数据，然后选中 ，触发el-form的验证
		const { index, message } = this.validData();
		if (this.data[index]) {
			this.data = this.data.map((v, i) => {
				v.isActived = index === i;
				this.activedIndex = index;
				return v;
			});
			if (this.mode === 1) {
				this.$nextTick(() => {
					message && this.$message.warning(message);
					this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });

					if ((this.$refs.config.$refs[this.data[index].fieldType] as ElForm).$refs.form) {
						((this.$refs.config.$refs[this.data[index].fieldType] as ElForm).$refs.form as ElForm).validate(noop);
					}
				});
				return;
			}
		}

		this.$nextTick(() => {
			if (message) {
				this.$message.warning(message);
				return;
			}

			new Promise((res) => {
				const refs = Object.keys(this.$refs.config)
					.filter((i) => {
						return this.$refs[i];
					})
					.filter((i) => {
						return i !== "uploadShopBg" && i !== "shopUploadLogo";
					});
				if (refs.length) {
					// 有，且只有一个需验证
					this.$refs[refs[0]].validate((flage) => {
						res(flage);
					});
				} else {
					res(true);
				}
			}).then((re) => {
				if (re) {
					let list = validateParams(cloneDeep(this.data));

					list = list
						.map((i) => {
							if (i.fieldType === "Swiper") {
								// 2021.05.12 去掉
								return undefined;
							}
							if (i.fieldType === "Site" && i.desc && Array.isArray(i.desc)) {
								i.desc = {
									siteLogo: "",
								};
							}
							if (i.fieldType === "guide" && i.desc && Array.isArray(i.desc)) {
								i.desc = {
									guideContent: "",
								};
							}
							if (i.fieldType === "iconMenu") {
								const { type, margin, borderRadius, backGround, isDefault } = i.desc;
								i.desc = {
									type,
									margin,
									borderRadius,
									isDefault,
									list: i.desc.list || [],
								};
							}
							if (i.fieldType === "LabelClass" && i.showClassType === 0) {
								(i as any).desc.list = [];
							}

							if (i.fieldType === "ShowWindow" || i.fieldType === "ShowWindowGroup") {
								// 2021.3.31  何波和颜俊要求去掉productList
								if (i.desc && i.desc.productList) {
									delete i.desc.productList;
								}
								if (i.desc && i.desc.caseGroup) {
									i.desc.caseGroup = (i.desc.caseGroup || []).map((v) => {
										if (v.productList) {
											delete v.productList;
										}
										return v;
									});
								}
								!i.sgwpId && (i.sgwpId = 0);
								delete i.sgwcgId;
							}

							if (i.fieldType === "QiKanShowWindow") {
								const { qiKanName, qiKanSize, qiKanType, qiKanNum, qiKanStyle, style, list } = i.desc;
								i.desc = {
									qiKanName,
									qiKanSize,
									qiKanType,
									qiKanNum,
									qiKanStyle,
									style,
									list: list || [],
								};
							}

							// 陈儒要求更改数据格式，直接改变动很大，所以取和提交时，数据转换一下
							if (i.fieldType === "Propagate") {
								i.desc = {
									pName: i.desc.pName,
									pWidth: i.desc.pWidth,
									pHeight: i.desc.pHeight,
									pMaxPage: i.desc.pMaxPage,
									pStyle: i.desc.pStyle,
									displayType: i.desc.displayType,
									margin: i.desc.margin,
									borderRadius: i.desc.borderRadius,
									backGround: i.desc.backGround,
									list: i.desc.list || [],
									config: {
										pStyle: i.desc.pStyle,
										displayType: i.desc.displayType,
										margin: i.desc.margin,
										borderRadius: i.desc.borderRadius,
										backGround: i.desc.backGround,
									},
								};
							}
							return i;
						})
						.filter(Boolean);
					const sgId = Number.parseInt(this.$route.params.id) || Number.parseInt(this.$route.params.sgId);
					const postParams = {
						sgId,
						showType: 2,
						list,
						siteId: +this.$route.params.siteId,
					};
					let loading = null;
					if (postParams.siteId) {
						loading = this.$loading({
							lock: true,
							text: "请稍等...",
							spinner: "el-icon-loading",
							background: "rgba(225,225,225,0.3)",
						});
					}
					if (!isPre) {
						if (this.mode === 1) {
							IPSService[ShopSaveService[this.mode]]({ postParams }).then(
								(res) => {
									if (res && res.result) {
										this.$message.success("保存成功");
									} else {
										this.$message.error("保存失败");
									}
									if (loading) {
										this.getData(loading);
									}
								},
								() => {
									if (loading) {
										loading.close();
									}
									this.$message.error("保存出错，请稍后重试");
								},
							);
						}
						if (this.mode === 2) {
							this.$confirm("请确保当前只有您在操作当前画面，否则可能导致保存布局操作覆盖其他人正在进行的作业").then(
								(result) => {
									if (result === "confirm") {
										const filterList = list.map((i) => {
											return { ygswpId: i.ygswpId, fieldType: i.fieldType };
										});
										const postParams = {
											showType: 2,
											siteId: +this.$route.params.siteId,
											list: filterList,
										};
										IPSService.componentLayoutSave({ postParams }).then(
											(res) => {
												if (res && res.result) {
													this.getData(loading);
													this.$message.success("保存成功");
												} else {
													this.$message.error("保存失败");
												}
											},
											() => {
												if (loading) {
													loading.close();
												}
												this.$message.error("保存出错，请稍后重试");
											},
										);
									}
								},
								() => {
									if (loading) {
										loading.close();
									}
								},
							);
						}
					} else {
						this.previewView(postParams, loading);
					}
				}
			});
		});
	}

	saveFlag(val) {
		if (val) {
			this.getData();
		}
	}

	changeCopyData(val) {
		this.copyData = val;
	}

	// 添加
	onAddItem(val: ItemArray) {
		const activedIndex = this.data.findIndex((v) => v.isActived);
		this.data = this.data.map((v, i) => {
			v = Object.assign(v, { isActived: false });
			return v;
		});

		val[val.length - 1].isActived = true;
		if (activedIndex === -1) {
			this.data = this.data.concat(val);
			this.copyData = this.copyData.concat(val);
		} else {
			this.data.splice(activedIndex + 1, 0, ...val);
			this.copyData.splice(activedIndex + 1, 0, ...val);
		}
		this.scrollToActived();
	}

	// 滚动到选定位置
	scrollToActived() {
		this.$nextTick(() => {
			if (this.$el.querySelector(".is-actived")) {
				this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
			}
		});
	}

	get dealPage() {
		console.log(this.fromPage);
		return this.fromPage && (this.fromPage === 1 || this.fromPage === 2);
	}

	render(h) {
		return (
			<section class={{ "nav-Menu shop": true, "no-padding height-100": this.dealPage }}>
				<div class={{ "nav-container relative-position": true, "no-padding": this.dealPage }} style="height: calc(100% - 51px)">
					{this.dealPage && (
						<div class="bottom-button" ref="bottomButton">
							<AddButton v-model={this.data} fromPage={this.fromPage} onAdd={this.onAddItem.bind(this)} class="flex" />
						</div>
					)}
					<div
						class={{
							"left-phone overflow-auto-y bg-white": true,
							"wid-240": !this.dealPage,
							"shop-left-phone absolute ": this.dealPage,
						}}>
						<ShopDisplay v-model={this.data} themeCode={Number(this.themeCode)} fromPage={this.fromPage} actData={this.copyData} onChangeData={this.changeCopyData.bind(this)}></ShopDisplay>
					</div>
					<ShopDisplayEdit
						attrButeList={this.connectedClass.map((v) => {
							v.value_name = v.attrName;
							v.value_no = v.attrCode;
							v.class_code = v.attrCode;
							v.isLeafe = !v.list || !v.list.length;
							return v;
						})}
						siteClassList={this.classList}
						v-model={this.data[this.activedIndex]}
						themeCode={Number(this.themeCode)}
						onSaveFlag={this.saveFlag.bind(this)}
						fromPage={this.fromPage}
						ref="config"
					/>
				</div>
				<div class="bottom-save">
					<el-button type="primary" class="wid-48 r-mr-14" onClick={this.save.bind(this, 0)}>
						{this.mode === 2 ? "保存布局" : "保存"}
					</el-button>
					{this.mode === 2 && (
						<span class="scopeSpan" onClick={this.save.bind(this, 1)}>
							预览
						</span>
					)}
				</div>
			</section>
		);
	}
}
